export const ADDRESS_VALIDATION_ERROR = {
  API_CHECKPOINT: 'validateAddress',
  API_ERROR_CODE: 'VALIDATION_ERROR',
  CLIENT_ERROR_CODE: 'apiValidationError',
  FIELDS: ['city', 'postalCode', 'state'],
};
